import React, { useEffect, useRef } from 'react';
import { useAuthorizationAsync } from '..';
import { APIContext, useAPIContext } from './Context';
export function AuthorizationProvider(props) {
    var startAuthorization = props.apiInstance;
    // нужен дефолтный контекст, до того как сходим в startup
    var defaultContext = useAPIContext();
    var apiContextRef = useRef();
    var _a = useAuthorizationAsync(), actions = _a[1];
    useEffect(function () {
        actions.start();
        return startAuthorization({
            onError: actions.error,
            onSuccess: function (api, response, headers) {
                apiContextRef.current = api;
                actions.success(response, headers);
            },
        });
    }, [actions, startAuthorization]);
    return (React.createElement(APIContext.Provider, { value: apiContextRef.current || defaultContext, children: props.children }));
}
